import {withDisplayErrorToUser} from "../error/error";
import {createDashboardPageViewModel} from "../../factories/dashboardPageFactory";
import settingsService from "../settings/settingsService";
import playgroundApi from "../playgroundApi";
import {dashboardStore} from "../../modules/dashboard/store/dashboardPageStore";

class DashboardPage {
  async loadDashboardViewModel() {
    // check if we should display the dashboard info modal the first time the user visits the page.
    const hasDashboardPageModalBeenDisplayedForTheFirstTime = settingsService.getHasDashboardModalBeenDisplayed();
    this.displayInfoModal(!hasDashboardPageModalBeenDisplayedForTheFirstTime);

    // notify settings that Dashboard modal has been displayed
    settingsService.changeHasDashboardModalBeenDisplayed(true);

    await withDisplayErrorToUser(async () => {
      // notify is loading
      this.changeRequestStatus("loading");
      try{
        // make request
        const myDashboardResponse = await playgroundApi.myDashboard();
        // update store
        dashboardStore.loadDashboardPage(createDashboardPageViewModel(myDashboardResponse));
        // notify loading complete
        this.changeRequestStatus("completed");
      } catch (e) {
        // notify loading error
        this.changeRequestStatus("error");
      }
    });
  }

  public resetDashboardViewModel() {
    dashboardStore.clearDashboardPage();
  }

  public displayInfoModal(isVisible: boolean) {
    dashboardStore.setDisplayDashboardInfoModal(isVisible);
  }

  protected changeRequestStatus(status: "loading" | "error" | "completed"): void {
    dashboardStore.setRequestStatus(status);
  }
}

export function displayInfoModal(isVisible: boolean) {
  dashboardStore.setDisplayDashboardInfoModal(isVisible);
}


const dashboard = new DashboardPage();
export default dashboard;
